import './src/assets/css/global'

// Utils
import {
	detectAndStoreAffiliateRef,
	getRefFromUrl,
	stripRefFromUrl
} from './src/utils/affiliate'

// App Context
import React from 'react'
import RootLayout from './src/components/Layouts/RootLayout'

export const wrapRootElement = ({ element }) => {
	return <RootLayout>{element}</RootLayout>
}

const STRAPI_BASE_URL = process.env.GATSBY_STRAPI_API_URL
const STRAPI_API_TOKEN = process.env.GATSBY_STRAPI_API_TOKEN

// NICHT mehr in onClientEntry die URL anfassen
export const onClientEntry = async () => {
	// Nur Strapi-Lookup & Session speichern — KEIN replaceState hier
	await detectAndStoreAffiliateRef({
		strapiBaseUrl: STRAPI_BASE_URL,
		apiToken: STRAPI_API_TOKEN
	})
}

// Nach der ersten Hydration die URL säubern
export const onInitialClientRender = () => {
	// nur wenn wirklich ?ref=... noch in der URL ist
	if (getRefFromUrl()) {
		// ganz leicht verzögern, damit EnsureResources durch ist
		requestAnimationFrame(() => {
			stripRefFromUrl()
		})
	}
}
